/**
 * @file: useDeliveryCheckReportModels.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { toMediaObject } from '@euler/app/flows/report/functions';
import { MediaObject } from '@euler/model';
import { DeliveryCheckSceneType } from '@euler/model/enum';
import {
  DeliveryCheckReportReworkRecord,
  VehicleReport,
} from '@euler/model/report';
import { useMemo } from 'react';

export type DeliveryCheckCellModel = {
  index: number;
  title: string;
  resultCode: string;
  resultText: string | undefined;
  unacceptedReason: string | undefined;
  technicianName: string;
  remark: string;
  timestamp: string | Date | undefined;
  medias: MediaObject[];
  reworkRecords: DeliveryCheckReportReworkRecord[] | undefined;
};

export function useDeliveryCheckReportModels(
  report: VehicleReport,
  sceneType: DeliveryCheckSceneType,
) {
  return useMemo(() => {
    const deliveryCheckReport =
      sceneType === DeliveryCheckSceneType.CompletionCheck
        ? report.deliveryCheck
        : report.samplingCheck;
    const items = deliveryCheckReport?.items.filter(x => x) ?? [];
    const cells = items.map((item, index) => {
      const cell: DeliveryCheckCellModel = {
        index,
        title: item.title,
        resultCode: item.resultCode,
        resultText: item.resultText ?? undefined,
        unacceptedReason: item.unacceptedReason ?? undefined,
        technicianName: item.technicianName ?? '',
        medias: item.medias.map(toMediaObject),
        timestamp: item.timestamp ?? deliveryCheckReport!.createdAt,
        reworkRecords: item.reworkRecords,
        remark:
          item.remark && item.remark !== '暂无备注'
            ? item.remark
            : item.resultCode === 'OK'
            ? '检查合格符合交车标准'
            : '检查不合格',
      };
      return cell;
    });
    return { cells };
  }, [report.deliveryCheck, report.samplingCheck, sceneType]);
}
